import { useAlertStore } from '@/store/alert.store'
import { AlertStatus, type Alert } from '@/types/nest/alert'
import { useRouter } from 'vue-router'

export function useOpenAlert() {
  const router = useRouter()
  const alertStore = useAlertStore()

  async function openAlert(alert: Alert) {
    if (!alert.url) return

    const url = new URL(alert.url, window.location.origin)
    if (url.origin === window.location.origin) {
      await router.push(url.pathname + url.search + url.hash)
    } else {
      window.open(url.href, '_blank', 'noopener')
    }

    if (alert.status === AlertStatus.UNREAD) {
      await alertStore.updateAlertStatus(alert.id, AlertStatus.READ)
    }
  }

  return { openAlert }
}
